import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { INTEGRATION_MODULE } from '../../configs/moduleNames';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_MAIS_EGU_LIST = '_LOAD_MAIS_EGU_LIST';
export const LOAD_MAIS_EGU_BY_ID = '_LOAD_MAIS_EGU_BY_ID';
export const EXPORT_MAIS_EGU_BY_ID = '_EXPORT_MAIS_EGU_BY_ID';
export const EDIT_MAIS_EGU_BY_ID = '_EDIT_MAIS_EGU_BY_ID';
export const LOAD_MAIS_EGU_LOGS_LIST = '_LOAD_MAIS_EGU_LOGS_LIST';
export const LOAD_CHECK_TYPES_LIST = '_LOAD_CHECK_TYPES_LIST';
export const LOAD_CHECK_TYPES_BY_ID = '_LOAD_CHECK_TYPES_BY_ID';
export const EDIT_CHECK_TYPES_BY_ID = '_EDIT_CHECK_TYPES_BY_ID';
export const ARCHIVE_CHECK_TYPES = '_ARCHIVE_CHECK_TYPES';
export const UNARCHIVE_CHECK_TYPES = '_UNARCHIVE_CHECK_TYPES';
export const CREATE_CHECK_TYPES = '_CREATE_CHECK_TYPES';
export const DELETE_CHECK_TYPES = '_DELETE_CHECK_TYPES';
export const LOAD_CHECKS_LIST = '_LOAD_CHECKS_LIST';
export const LOAD_CHECKS_BY_ID = '_LOAD_CHECKS_BY_ID';
export const LOAD_FILE_EXPORT_LIST = '_LOAD_FILE_EXPORT_LIST';
export const LOAD_FILE_EXPORT_BY_ID = '_LOAD_FILE_EXPORT_BY_ID';
export const EDIT_FILE_EXPORT_BY_ID = '_EDIT_FILE_EXPORT_BY_ID';
export const CREATE_FILE_EXPORT = '_CREATE_FILE_EXPORT';

export const loadMaisEguList = createDeferredAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LIST);
export const loadMaisEguListSuccessful = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LIST + SUCCESSFUL);
export const loadMaisEguListFailed = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LIST + FAILED);

export const loadMaisEguById = createDeferredAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_BY_ID);
export const loadMaisEguByIdSuccessful = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_BY_ID + SUCCESSFUL);
export const loadMaisEguByIdFailed = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_BY_ID + FAILED);

export const exportMaisEguById = createDeferredAction(INTEGRATION_MODULE + EXPORT_MAIS_EGU_BY_ID);
export const exportMaisEguByIdSuccessful = createAction(INTEGRATION_MODULE + EXPORT_MAIS_EGU_BY_ID + SUCCESSFUL);
export const exportMaisEguByIdFailed = createAction(INTEGRATION_MODULE + EXPORT_MAIS_EGU_BY_ID + FAILED);

export const editMaisEguById = createDeferredAction(INTEGRATION_MODULE + EDIT_MAIS_EGU_BY_ID);
export const editMaisEguByIdSuccessful = createAction(INTEGRATION_MODULE + EDIT_MAIS_EGU_BY_ID + SUCCESSFUL);
export const editMaisEguByIdFailed = createAction(INTEGRATION_MODULE + EDIT_MAIS_EGU_BY_ID + FAILED);

export const loadMaisEguLogsList = createDeferredAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LOGS_LIST);
export const loadMaisEguLogsListSuccessful = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LOGS_LIST + SUCCESSFUL);
export const loadMaisEguLogsListFailed = createAction(INTEGRATION_MODULE + LOAD_MAIS_EGU_LOGS_LIST + FAILED);

export const loadCheckTypesList = createDeferredAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST);
export const loadCheckTypesListBegin = createAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST + BEGIN);
export const loadCheckTypesListSuccessful = createAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST + SUCCESSFUL);
export const loadCheckTypesListFailed = createAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST + FAILED);

export const loadCheckTypesById = createDeferredAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_BY_ID);
export const loadCheckTypesByIdSuccessful = createAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_BY_ID + SUCCESSFUL);
export const loadCheckTypesByIdFailed = createAction(INTEGRATION_MODULE + LOAD_CHECK_TYPES_BY_ID + FAILED);

export const editCheckTypesById = createDeferredAction(INTEGRATION_MODULE + EDIT_CHECK_TYPES_BY_ID);
export const editCheckTypesByIdSuccessful = createAction(INTEGRATION_MODULE + EDIT_CHECK_TYPES_BY_ID + SUCCESSFUL);
export const editCheckTypesByIdFailed = createAction(INTEGRATION_MODULE + EDIT_CHECK_TYPES_BY_ID + FAILED);

export const archiveCheckTypes = createDeferredAction(INTEGRATION_MODULE + ARCHIVE_CHECK_TYPES);
export const archiveCheckTypesSuccessful = createAction(INTEGRATION_MODULE + ARCHIVE_CHECK_TYPES + SUCCESSFUL);
export const archiveCheckTypesFailed = createAction(INTEGRATION_MODULE + ARCHIVE_CHECK_TYPES + FAILED);

export const unarchiveCheckTypes = createDeferredAction(INTEGRATION_MODULE + UNARCHIVE_CHECK_TYPES);
export const unarchiveCheckTypesSuccessful = createAction(INTEGRATION_MODULE + UNARCHIVE_CHECK_TYPES + SUCCESSFUL);
export const unarchiveCheckTypesFailed = createAction(INTEGRATION_MODULE + UNARCHIVE_CHECK_TYPES + FAILED);

export const createCheckTypes = createDeferredAction(INTEGRATION_MODULE + CREATE_CHECK_TYPES);
export const createCheckTypesSuccessful = createAction(INTEGRATION_MODULE + CREATE_CHECK_TYPES + SUCCESSFUL);
export const createCheckTypesFailed = createAction(INTEGRATION_MODULE + CREATE_CHECK_TYPES + FAILED);

export const deleteCheckTypes = createDeferredAction(INTEGRATION_MODULE + DELETE_CHECK_TYPES);
export const deleteCheckTypesSuccessful = createAction(INTEGRATION_MODULE + DELETE_CHECK_TYPES + SUCCESSFUL);
export const deleteCheckTypesFailed = createAction(INTEGRATION_MODULE + DELETE_CHECK_TYPES + FAILED);

export const loadChecksList = createDeferredAction(INTEGRATION_MODULE + LOAD_CHECKS_LIST);
export const loadChecksListBegin = createAction(INTEGRATION_MODULE + LOAD_CHECKS_LIST + BEGIN);
export const loadChecksListSuccessful = createAction(INTEGRATION_MODULE + LOAD_CHECKS_LIST + SUCCESSFUL);
export const loadChecksListFailed = createAction(INTEGRATION_MODULE + LOAD_CHECKS_LIST + FAILED);

export const loadChecksById = createDeferredAction(INTEGRATION_MODULE + LOAD_CHECKS_BY_ID);
export const loadChecksByIdSuccessful = createAction(INTEGRATION_MODULE + LOAD_CHECKS_BY_ID + SUCCESSFUL);
export const loadChecksByIdFailed = createAction(INTEGRATION_MODULE + LOAD_CHECKS_BY_ID + FAILED);

export const loadFileExportList = createDeferredAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_LIST);
export const loadFileExportListSuccessful = createAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_LIST + SUCCESSFUL);
export const loadFileExportListFailed = createAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_LIST + FAILED);

export const loadFileExportById = createDeferredAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_BY_ID);
export const loadFileExportByIdSuccessful = createAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_BY_ID + SUCCESSFUL);
export const loadFileExportByIdFailed = createAction(INTEGRATION_MODULE + LOAD_FILE_EXPORT_BY_ID + FAILED);

export const createFileExport = createDeferredAction(INTEGRATION_MODULE + CREATE_FILE_EXPORT);
export const createFileExportSuccessful = createAction(INTEGRATION_MODULE + CREATE_FILE_EXPORT + SUCCESSFUL);
export const createFileExportFailed = createAction(INTEGRATION_MODULE + CREATE_FILE_EXPORT + FAILED);

export const editFileExportById = createDeferredAction(INTEGRATION_MODULE + EDIT_FILE_EXPORT_BY_ID);
export const editFileExportByIdSuccessful = createAction(INTEGRATION_MODULE + EDIT_FILE_EXPORT_BY_ID + SUCCESSFUL);
export const editFileExportByIdFailed = createAction(INTEGRATION_MODULE + EDIT_FILE_EXPORT_BY_ID + FAILED);
